module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-array-edit"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('selectize-vehicle-attribute', {
    staticClass: "input-group-field",
    on: {
      "optionSelected": _vm.setValue
    },
    model: {
      value: (_vm.newName),
      callback: function($$v) {
        _vm.newName = $$v
      },
      expression: "newName"
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "button fa fa-plus",
    attrs: {
      "disabled": !_vm.newName
    },
    on: {
      "click": _vm.addField
    }
  })])], 1), _vm._l((_vm.values), function(value, label) {
    return (typeof value !== 'undefined') ? _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [_vm._v(_vm._s(label))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[label].value),
        expression: "values[label].value"
      }],
      staticClass: "input-group-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.values[label].value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.values[label], "value", $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button warning fa fa-times",
      on: {
        "click": function($event) {
          return _vm.removeField(label)
        }
      }
    })])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63a8cf04!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/SelectizeVehicleAttributesArrayEdit.vue
// module id = 2539
// module chunks = 1